import { atom } from "recoil";

export const LocationPermissionState = atom<string>({
	key: 'location-permission-state-key',
	default: '',
});
